<template>
    <div class="container-fluid">
        <div class="herosection"
            :style="{
                backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '924px'
            }"
        >
            <NavbarSection />
            <!-- <div class="overlay-img"></div> -->
            <div class="heroWriteup">
                <p v-html="description"></p>
            </div>
        </div>
        
       <ProgramOverview />

    <!-- Categories -->
    <div class="categories">
        <h2>Categories of Players</h2>

        <div class="scroll-wrapper">
            <div class="scroll-track">
                <div v-for="event in sportsEvents" :key="event.id" class="event-card">
                    <div class="image-wrapper">
                        <img :src="event.image" :alt="event.name" />
                    </div>
                    <h3>{{ event.name }}</h3>
                    <p>{{ event.description }}</p>
                </div>
                <div v-for="event in sportsEvents" :key="'duplicate-' + event.id" class="event-card">
                    <div class="image-wrapper">
                        <img :src="event.image" :alt="event.name" />
                    </div>
                    <h3>{{ event.name }}</h3>
                    <p>{{ event.description }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Coaches -->
    <div class="coaches">
        <p>&nbsp;</p>
        <h2 class="mt-4">Meet Our Coaches</h2>
        <p class="mt-4">LLTC's coaching team are LTA accredited, DBS checked and first aid qualified.</p>

        <!-- Scroll Wrapper -->
        <CoacheSlider v-if="dataList.length" :people="formattedPeople" />
        <p>&nbsp;</p>
    </div>

    <FooterSection />
</div>
</template>

<script setup>
/* eslint-disable */
import NavbarSection from '@/components/NavbarSection.vue';
import ProgramOverview from '@/components/ProgramOverview.vue';
import adultscategories from '@/assets/images/sports/adultscategories.png';
import FooterSection from '@/components/FooterSection.vue';
import CoacheSlider from '../components/AboutComponents/CoacheSlider.vue';
import { ref, onMounted,computed, onBeforeUnmount } from "vue";
import axios from 'axios';

let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref([]);

const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');
const scrollContainer = ref(null);
let cardFullWidth = 330; // fallback

onBeforeUnmount( async () => {
  
});

onMounted(async () => {
    await listCoaches();
    await listBanner()

   // find first card and compute width + right margin
  const first = scrollContainer.value && scrollContainer.value.querySelector('.coach-container');
  if (first) {
    const rect = first.getBoundingClientRect();
    const style = window.getComputedStyle(first);
    const marginRight = parseFloat(style.marginRight || 0);
    cardFullWidth = Math.round(rect.width + marginRight);
  }

  // optional: ensure scroll starts at 0
  if (scrollContainer.value) scrollContainer.value.scrollLeft = 0;
});

// Format data for ImageSlider
const formattedPeople = computed(() =>
  dataList.value.map(person => ({
    name: person.fullname,
    position: person.title,
    email: person.email,
    phone: person.phone,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
)

const scrollLeft = () => {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollBy({
    left: -(cardFullWidth * 2),
    behavior: 'smooth'
  });
};

const scrollRight = () => {
  if (!scrollContainer.value) return;
  scrollContainer.value.scrollBy({
    left: cardFullWidth * 2,
    behavior: 'smooth'
  });
};

const listBanner = async () => {
  try {
    const config = 'program-overview';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};


const sportsEvents = ref([
    {
        id: 1,
        name: 'Adult Players',
        description:
            'Enthusiasts of all levels who play for fitness, fun, and friendly competition.',
        image: adultscategories,
    },
    {
        id: 2,
        name: 'Youth Players',
        description: 'Young athletes developing skills and teamwork through sports.',
        image: adultscategories,
    },
    {
        id: 3,
        name: 'Professional Players',
        description:
            'Competitive players participating in tournaments and leagues.',
        image: adultscategories,
    },
]);

const listCoaches = async () => {
  try {
    const response = await axios.get('/coaches_list.php', { });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style lang="scss" scoped>

.herosection {
    border-radius: 20px;
    background: #fff;
    background-size: cover;
    height: 350px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
    background-image: url('../assets/images/media_gallery/media.png');
}
/* Dark overlay */
.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Adjust opacity for darkness */
    z-index: 1;
    /* sits above images but below content */
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
   // background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}
.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}


.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: left;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;

    }
}
.categories {
    margin: 40px 0;

    h2 {
        font-size: 52px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        margin-bottom: 30px;
    }
}

.scroll-wrapper {
    width: 100%;
    overflow: hidden;
    position: relative;
}

.scroll-track {
    display: flex;
    gap: 20px;
    animation: scroll-left 20s linear infinite;
}

@keyframes scroll-left {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-50%);
    }
}

.event-card {
    min-width: 300px;
    background: #fff;
    border-radius: 28px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 28px;
    text-align: center;
    border: 1px solid #e7e7e7;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    .image-wrapper {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        background-color: #8bdc74;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    img {
        width: 28px;
    }

    h3 {
        font-size: 20px;
        font-weight: 600;
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: center;
    }

    p {
        font-size: 14px;
        color: #6d6d6d;
        margin-bottom: 5px;
        text-align: center;
        font-weight: 400;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
    }
}


/* Coaches Section */
.coaches {
  position: relative;
  background: url("../assets/images/program_bg.jpg") center/cover no-repeat;
  margin: 60px 0;
  z-index: 1;
  min-height: 100vh;

  // Overlay
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: #9E2D0FCC; // your overlay color
    z-index: -1;
  }

  // Text and content stay above overlay
  * {
    position: relative;
    z-index: 2;
  }

  h2 {
    color: #FFFFFF;
    font-weight: 400;
    font-style: Regular;
    font-size: 48px;
    line-height: 100%;
    letter-spacing: 0.2%;
    text-align: center;

  }
  p {
    color: #FFFFFF;
  }
}

.coaches-grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: 20px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .coaches {

       padding: 0px;
    }
    .coaches-grid {
        display: flex;
        flex-direction: row !important;
    }

    .coach-container{
        width: 300px !important;
    }
}
.coach-container{
    width: 305px;
    height: 480px;
    gap: 28px;
    opacity: 1;
    padding-bottom: 20px;
    border-radius: 12px;
    border: 1px solid #FFFFFF;
    backdrop-filter: blur(20px);
    background: #FFFFFF26;
    margin: 10px;
    padding: 10px;

    img{
        border-radius: 12px;
        width: 100%;
        height: 280px;
        opacity: 1;
        
    }
}
.image-text{
    
    h4{
        //font-family: BT Beau Sans;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0%;
        text-align: center;
        color: #FFFFFF;
    }
    p{
        margin-top: -20px;
        font-size: 13px;
        text-align: center;
        color: #FFFFFF;
        line-height: 1.4 ;
    }
}
.email-img {
  //width: 50px;                /* adjust size as needed */
  //height: 50px;               /* keep equal width and height for a perfect circle */
  //border-radius: 50%;          /* makes it a circle */
  border: 0px solid #fff;      /* white border */
  overflow: hidden;            /* ensures image doesn’t overflow the circle */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;  
  cursor: pointer;   /* optional: faint background if image has transparency */
}

.email-img img {
  margin-top: 4px;
  width: 50%;
  height: 50%;
  object-fit: cover;           /* ensures the image fills the circle nicely */
  //border-radius: 50%;          /* keeps image circular */
}

/* Horizontal scroll wrapper */
.scroll-wrapper2 {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 20px;
}

/* Make your row scroll horizontally */
/* make the track a nowrap flex row */
@media (min-width: 992px) {
  .scroll-wrapper2 { max-width: calc( (505px + 20px) * 3 ); margin: 0 auto; } /* adjust numbers to match your card width + gap */
}

@media (max-width: 768px) {
  .scroll-btn { display: none; }
  .scroll-x { flex-direction: column; overflow: visible; }
}

.scroll-x {
  display: flex !important;
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  gap: 20px; /* keep space between cards (you already use margin in .coach-container too) */
  padding-bottom: 8px;
}

/* ensure coach-container acts as a fixed card in the scroller */
.scroll-x .coach-container {
  /* keep your existing width, or adapt if you want exact size */
  flex: 0 0 auto;
}

/* hide scrollbar */
.scroll-x::-webkit-scrollbar { display: none; }
.scroll-x { -ms-overflow-style: none; scrollbar-width: none; }

/* buttons (kept from your earlier example) */
.scroll-btn {
  position: absolute;
  top: 46%;
  transform: translateY(-50%);
  background: #ffffff55;
  color: #fff;
  border: 1px solid #fff;
  width: 40px;
  height: 40px;
  font-size: 28px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 30;
  backdrop-filter: blur(4px);
}
.scroll-btn.left { left: 4px; }
.scroll-btn.right { right: 4px; }

/* optional: snap to cards */
.scroll-x { scroll-snap-type: x mandatory; }
.scroll-x .coach-container { scroll-snap-align: center; }

</style>
